<ui-skeleton [uiActive]="true" [uiTitle]="false" [uiParagraph]="{ rows: 3, width: ['90%', '80%', '10%'] }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-sm' }" />
